import { render, staticRenderFns } from "./EditAddMethodsOrgaAndFunc.vue?vue&type=template&id=29afedfe&scoped=true"
import script from "./EditAddMethodsOrgaAndFunc.vue?vue&type=script&lang=js"
export * from "./EditAddMethodsOrgaAndFunc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29afedfe",
  null
  
)

export default component.exports